module.exports = __webpack_public_path__ + "img/chest-silhouette.f9c20e61.webp";